function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 8C0 7.44772 0.447715 7 1 7H47C47.5523 7 48 7.44772 48 8C48 8.55228 47.5523 9 47 9H0.999999C0.447714 9 0 8.55228 0 8Z",
  fill: "#EAEEF4"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 18.334,
  y: 14.3333,
  width: 36,
  height: 2,
  rx: 1,
  fill: "#EAEEF4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M118 45.875C118 45.3918 118.392 45 118.875 45H165.125C165.608 45 166 45.3918 166 45.875C166 46.3582 165.608 46.75 165.125 46.75H118.875C118.392 46.75 118 46.3582 118 45.875Z",
  fill: "#EAEEF4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M113 51.125C113 50.6418 113.392 50.25 113.875 50.25H142.125C142.608 50.25 143 50.6418 143 51.125C143 51.6082 142.608 52 142.125 52H113.875C113.392 52 113 51.6082 113 51.125Z",
  fill: "#EAEEF4"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 79,
  cy: 87.5,
  rx: 60,
  ry: 9.5,
  fill: "#F5F8FA"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 17,
  r: 17,
  fill: "#EAEEF4"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 103.5,
  cy: 35.5,
  r: 11.5,
  fill: "#EAEEF4"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M95.9708 58.6325C93.1607 61.4191 87.2849 67.2464 83.2414 71.2564C80.8981 73.5804 77.1031 73.5816 74.7598 71.2576C70.787 67.3175 65.0248 61.603 62.0295 58.6325C52.6568 49.3373 52.6568 34.2666 62.0295 24.9714C71.402 15.6762 86.5982 15.6762 95.9708 24.9714C105.343 34.2666 105.343 49.3373 95.9708 58.6325Z",
  fill: "url(#paint0_linear)",
  stroke: "url(#paint1_linear)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M88 42C88 46.9707 83.9707 51 79 51C74.0293 51 70 46.9707 70 42C70 37.0294 74.0293 33 79 33C83.9707 33 88 37.0294 88 42Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 31,
  y1: 45.5,
  x2: 85.4943,
  y2: 93.0586,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007CFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 31,
  y1: 45.5,
  x2: 85.4943,
  y2: 93.0586,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007CFF"
})));

function SvgLocationBluePoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 97,
    viewBox: "0 0 166 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = React.forwardRef(SvgLocationBluePoint);
export default __webpack_public_path__ + "static/media/location-blue-point.9711095e.svg";
export { ForwardRef as ReactComponent };